import { h } from 'vue';

import { CdsButton } from '../../../CdsButton';

import type { NTable } from '../../interface';
import type { TSize } from '@components/composable';

interface IDefaultExpandIconProps<RecordType> {
  record: RecordType;
  isTree?: boolean;
  expanded: boolean;
  expandable: boolean;
  onExpand: (record: RecordType, event: MouseEvent) => void;
}

export function renderExpandIcon<RecordType>(locale: NTable.ILocale, size: TSize) {
  return function expandIcon<RecordType>({
    record,
    isTree,
    expanded,
    expandable,
    onExpand
  }: IDefaultExpandIconProps<RecordType>) {
    const iconPrefix = 'cds-table__row-expand-icon';
    const icon = isTree ? (expanded ? 'minus' : 'plus') : 'chevron-right';

    return h(CdsButton, {
      type: 'button',
      appearance: 'tertiary',
      icon,
      size: 'sm',
      class: {
        'cds-table__row-expand-icon': true,
        [`${iconPrefix}--tree`]: isTree,
        [`${iconPrefix}--spaced`]: !expandable,
        [`${iconPrefix}--expanded`]: expandable && expanded,
        [`${iconPrefix}--collapsed`]: expandable && !expanded
      },
      ariaLabel: expanded ? locale.collapse : locale.expand,
      onClick: (event: MouseEvent) => {
        onExpand(record, event);
        event.stopPropagation();
      }
    });
  };
}
